/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Chip from 'solis/claude/primitive/chip';

import EnergyIcon from 'svg/shared/modern/energy';


export default ({ influence }) =>
{
  return influence > 0 ? <Chip icon = {<EnergyIcon />} text = {influence} /> : null;
};
